import { safeLevelFromAvg } from '@/data/mockSafeData';
import type { FundamentalCatalogItem } from '@/api/types';

export function buildNarrative(
  strengths: { id: string; avg: number }[],
  growth: { id: string; avg: number }[],
  currentAvg: number,
  pastAvg: number,
  tFn: (key: string, opts?: Record<string, unknown>) => string,
  levelLabels: readonly string[],
  catalogData: FundamentalCatalogItem[],
  lang: string,
): string {
  const fundName = (id: string) => {
    const f = catalogData.find(x => x.id === id);
    return f?.shortNames?.[lang] ?? f?.shortName ?? f?.names?.[lang] ?? id;
  };
  const pieces: string[] = [];
  if (strengths.length > 0) {
    const { idx } = safeLevelFromAvg(strengths[0].avg);
    pieces.push(tFn('safe.narrativeStrength', { fund: fundName(strengths[0].id).toLowerCase(), level: levelLabels[idx] }));
    if (strengths.length > 1) {
      const others = strengths.slice(1).map(s => fundName(s.id).toLowerCase()).join(' y ');
      pieces.push(tFn('safe.narrativeConsistency', { others }));
    }
  }
  if (currentAvg > 0 && pastAvg > 0) {
    const diff = Math.round((currentAvg - pastAvg) * 10) / 10;
    if (diff > 0) pieces.push(tFn('safe.narrativeProgress'));
    else if (diff === 0) pieces.push(tFn('safe.narrativeStable'));
    else pieces.push(tFn('safe.narrativeVariation'));
  }
  if (growth.length > 0) {
    const { idx } = safeLevelFromAvg(growth[0].avg);
    const nextLabel = idx < 3 ? levelLabels[idx + 1] : levelLabels[3];
    pieces.push(tFn('safe.narrativeNextLevel', { fund: fundName(growth[0].id).toLowerCase(), level: nextLabel }));
  }
  return pieces.join(' ');
}
